module.exports = __webpack_public_path__ + "img/42-r.83e3d5fe.png";